angular.module('app.cessao').factory('integracaoCessaoPorCallbackFactory', function ($http, errorService) {
    var _apiName = 'IntegracaoCessaoPorCallback';

    var _listarIntegracoes = function (options, dataInicio, dataTermino, stituacaoIntegracao, produtoRede, tipoLayoutFundo, search) {
        var dto = options.data;
        dto.parms = [];
        dto.search = search;
        dto.parms.push({ "name": "DataInicio", "value": dataInicio });
        dto.parms.push({ "name": "DataTermino", "value": dataTermino });
        dto.parms.push({ "name": "Situacao", "value": stituacaoIntegracao });
        dto.parms.push({ "name": "ProdutoRede", "value": produtoRede });
        dto.parms.push({ "name": "TipoLayoutFundo", "value": tipoLayoutFundo })

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListarIntegracoes', dto);
    };

    var _reprocessar = function (dataItem) {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/Reprocessar', dataItem);
    };

    var _findRecord = function (id) {
        var dto = {};
        dto.id = id;
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/FindRecord', dto);
    };

    var _listarSituacoes = function () {
        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ListarSituacoes');
    };

    var _obterMsgsIntegracao = function (options, id) {
        var dto = options.data;
        dto.parms = [];
        dto.parms.push({ "name": "CodigoIntegracao", "value": id });

        $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ObterMensagens', dto).then(function (response) {
            options.success(response.data);
        }, function (response) {
            var erro = {};
            erro.data = response.data;
            errorService.processError(erro, options);
        });
    };

    var _obterCallbacksIntegracao = function (options, id) {
        var dto = {};
        dto.id = id;

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ObterCallbacksIntegracao', dto)
    };

    var _obterJsonEnvio = function (id) {
        var dto = {};
        dto.id = id;

        return $http.post(appConfig.serviceBase + 'api/' + _apiName + '/ObterJsonEnvio', dto)
    };

    var factory = {};

    factory.listarIntegracoes = _listarIntegracoes;
    factory.reprocessar = _reprocessar;
    factory.findRecord = _findRecord;
    factory.listarSituacoes = _listarSituacoes;
    factory.obterMsgsIntegracao = _obterMsgsIntegracao;
    factory.obterCallbacksIntegracao = _obterCallbacksIntegracao;
    factory.obterJsonEnvio = _obterJsonEnvio;

    return factory;
});